import { createAsyncThunk } from "@reduxjs/toolkit";
import { FetchRequestHandler } from "../../utils/commonUtilities";
import { baseUrl } from "../../constants/Endpoints/EndPoints";


export const fetchMyaccountLogin = createAsyncThunk(
    "fetchMyAccountLogin",
    async() => {
        const response = await FetchRequestHandler(
            "get",
            `${baseUrl}api/security/refresh-token`,
        );
        return response;
    }
)

export const fetchUpdateToken = createAsyncThunk(
    "fetchUpdateToken",
    async(payload) => {
        const response = await FetchRequestHandler(
            "post",
            `${baseUrl}api/security/update-token`,
            payload
        );
        return response;
    }
)

export const updateLoginInformation = createAsyncThunk(
    "updateLoginInformation",
    async(payload) => {
        const response = await FetchRequestHandler(
            "post",
            `${baseUrl}api/users/update-login-information`,
            payload
        );
        return response;
    }
)

export const updatePassword = createAsyncThunk(
    "updatePassword",
    async(payload) => {
        const response = await FetchRequestHandler(
            "post",
            `${baseUrl}api/users/update-password`,
            payload
        );
        return response;
    }
)